export default __webpack_public_path__ + "static/media/034-message.83022214.svg";